const environmentLocal = {
  environment: process.env.REACT_APP_ENVIRONMENT,
  isAmbienteManutencao: process.env.REACT_APP_IS_DIEF_AMBIENTE_MANUTENCAO,
  periodoEstimado: process.env.REACT_APP_DIEF_PERIODO_ESTIMADO_MANUTENCAO,
};

export const environment = {
  environment: environmentLocal.environment || 'pro',
};

export const manutencaoDief = {
  isAmbienteManutencao: environmentLocal.isAmbienteManutencao ?? 'false',
  periodoEstimado: environmentLocal.periodoEstimado ?? '05/03/2036 a 06/03/2026',
};
